import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './article-hero-banner.component.scss';
var ArticleHeroBanner = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleHeroBanner, _super);
    function ArticleHeroBanner(element) {
        return _super.call(this, element) || this;
    }
    ArticleHeroBanner.prototype.init = function () {
    };
    ArticleHeroBanner.prototype.bindEvents = function () {
    };
    return ArticleHeroBanner;
}(Base));
export { ArticleHeroBanner };



//////////////////
// WEBPACK FOOTER
// ./components/article-hero-banner/article-hero-banner.component.ts
// module id = 656
// module chunks = 0